
     <form [formGroup]="formEdit" >
     <mat-dialog-content>
     <img src="/assets/wait2.gif" height="150px" />
      </mat-dialog-content>
    </form>
  